<template>
  <v-container fluid>
    <d-table
      :data_object="dataObject"
      :getFreshData="true"
      :linkClick="linkClick"
      :tableHeight="tableHeight"
      :table_title="table_title"
      :link="link"
      :directEdit="false"
      :itemsPerPage="15"
      :noDelete="true"
      :key="tableKey"
      :noExcel="true"
      :toolBarControls="toolBarControls"
    />
    <!-- <v-data-calendar
      :eventTemplate="eventTemplate"
      :curDate="serviceDate"
      :data-object="dataObject"
      :getQry="todayQry"
      :getEventColor="getEventColor"
      :eventClick="eventClick"
      calHeight="210px"
      defaultType="day"
      :disableTools="true"
      :firstInterval="firstInterval"
      :hideHeader="true"
      :key="calendarKey"
      :onDataReceived="onDataReceived"
      ref="cal"
    >
    </v-data-calendar> -->
  </v-container>
</template>

<script>
import * as fun from "../../plugins/common";
export default {
  name: "TodayJobs",
  components: {
    // VDataCalendar: () => import("../../components/DataCalendar.vue"),
    DTable: () => import("../../components/Table.vue"),
  },
  props: {
    linkClick: Function,
    startDate: String,
    endDate: String,
    link: Object,
  },
  data() {
    return {
      table_title: "Jobs Performing Today",
      tableHeight: 200,
      tableKey: 0,
      dateRange: "",
      toolBarControls: [
        {
          comp: "v-date-range-picker",
          id: "dates",
          "v-bind": {},
        },
      ],
      serviceDate: null,
      todayData: [],
      firstInterval: 0,

      dataObject: {
        object_name: "v_schedule_cal",
        all_records: true,
        date_fields: ["date"],
        fields_excluded: [
          "date",

          "customer",
          "stops",
          "color",
          "lead_id",
          "volume",
          "weight",
          "mileage",
          "book_date",
          "status",
          "foreman",
          "pickup_status",
        ],
        qry: {
          // date: {
          //   $gte: fun.formatDate(this.startDate, true, null, true),
          //   $lt: fun.formatDate(this.endDate, true, null, true),
          // },
        },
      },
    };
  },
  mounted() {
    this.dateRange =
      fun.formatDate(new Date(), false, false, true) +
      "-" +
      fun.formatDate(new Date(), false, false, true);
    // this.dateRange=this.startDate = new Date(start.setDate(start.getDate()));

    this.toolBarControls[0]["v-bind"].dateChange = this.dateChange;
    this.updateQry();
    // this.updateDateRange();
  },
  beforeDestroy() {},
  methods: {
    dateChange(r) {
      console.log(r);
      var dateRange = r.split("-");
      if (
        new Date(dateRange[0]) != this.startDate &&
        new Date(dateRange[dateRange.length - 1]) != this.endDate
      ) {
        this.startDate = new Date(dateRange[0]);
        this.endDate = new Date(dateRange[dateRange.length - 1]);
      }

      // if (this.startDate != this.endDate) {
      this.updateDateRange();
      // if (this.startDate.toISOString() == this.endDate.toISOString()) {
      this.endDate = this.endDate.addDays(1);
      // }
      this.updateQry();

      // }
      // this.dateChange = !this.dateChange;
      //
    },
    updateQry() {
      this.dataObject.qry = this.$root.getQry();
      this.dataObject.qry.$and.push({
        date: { $gte: fun.formatDate(this.startDate, true) },
      });
      this.dataObject.qry.$and.push({
        date: { $lt: fun.formatDate(this.endDate, true) },
      });

      //   $and: [

      //   ],
      // };

      // if (this.$root.filterShipments()) {
      //   this.dataObject.qry.$and.push({ sales_person: this.$root.user_id });
      // }

      // if (this.$root.filteredCompanies()) {
      //   if (!this.dataObject.id_fields) {
      //     this.dataObject.id_fields = [];
      //   }
      //   this.dataObject.id_fields.push("_id");
      //   // var list_of_company_ids = this.$root.store.userData.company.map(
      //   //   (c) => c._id["$oid"]
      //   // );
      //   var filterCompanyQry = {
      //     "company._id": { $in: this.$root.filteredCompanies() },
      //   };
      //   if (!this.dataObject.qry.$and) {
      //     this.dataObject.qry.$and = [];
      //   }
      //   this.dataObject.qry.$and.push(filterCompanyQry);
      // }
      this.tableKey = !this.tableKey;
    },
    updateDateRange() {
      this.dateRange =
        fun.formatDate(this.startDate, false, false, true) +
        "-" +
        fun.formatDate(this.endDate, false, false, true);
      this.toolBarControls[0]["v-bind"].vModel = this.dateRange;
    },
    refresh() {
      var dateFrame = this.$refs.cal.dateFrame;
      this.$refs.cal.getEvents(dateFrame);
    },
    // onDataReceived(data) {
    //   this.todayData = data.model;

    //   return data;
    // },
    getEventColor(event) {
      return event.color || this.defaultEventColor;
    },
    todayQry() {
      this.dataObject.qry = {
        date: {
          $gte: fun.formatDate(this.startDate, true, null, true),
          $lt: fun.formatDate(this.endDate, true, null, true),
        },
      };

      return this.dataObject;
    },
    eventTemplate(e) {
      var end = new Date(e.date);
      end.setHours(end.getHours() + 2);
      var ev;
      if (e.reminder_date) {
        ev = {
          name:
            e.contact.first_name +
            " " +
            e.contact.last_name +
            " #" +
            e.shipment_id +
            " " +
            e.description,
          shipment_id: e.shipment_id,
          start: e.date,
          first_name: e.contact.first_name,
          last_name: e.contact.last_name,
          end: fun.formatDate(end, true, true, true),
          color: e.color,
          timed: true,
        };
      } else {
        // if (!new Date(e.date).getHours()) {
        //   e.date = new Date(e.date).setHours(8);
        e.date = fun.formatDate(e.date, true, true, true);
        // }
        ev = {
          name:
            e.customer.contact.first_name +
            " " +
            e.customer.contact.last_name +
            " #" +
            e.shipment_id,
          shipment_id: e.shipment_id,
          start: e.date,
          first_name: e.customer.contact.first_name,
          last_name: e.customer.contact.last_name,
          end: fun.formatDate(end, true, true, true),
          color: e.color,
          timed: true,
        };
      }
      return ev;
    },
  },
};
</script>

<style lang="css" scoped></style>
